module.exports = __webpack_public_path__ + "static/media/carriers-small.a198c83a.webp";